
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryHorizontal100 as ObiBatteryHorizontal100Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-horizontal-100.js';
 
 
 

 
 export const ObiBatteryHorizontal100 = createComponent({
   react: React,
   tagName: 'obi-battery-horizontal-100',
   elementClass: ObiBatteryHorizontal100Element,
   events: {
     
   }
  });
 
 